/**
 * Page shell. Wraps the Nav + main content, applies the page background,
 * and renders the cursor-following triangle grid as a non-interactive
 * backdrop behind the content.
 *
 * Stacking architecture:
 *   - `isolate` on the root scopes blend/z-index behavior to this page.
 *   - The grid sits at z-0, behind the cards, so their backdrop-blur classes
 *     can sample and blur the triangle pattern.
 *   - A light frosted pane sits above the grid and below content, softening
 *     the background effect without blurring text or cards.
 *   - Main content sits at z-10 so cards and text remain readable.
 *   - Nav keeps its own z-50 layer above the page content; the StageBanner
 *     (staging only) sits above it along the top edge, and <main> pads for
 *     its height (`--stage-banner-h`, index.css; 0 off staging).
 */
import { Nav } from "./Nav";
import { StageBanner } from "./StageBanner";
import { TriangleGrid } from "./TriangleGrid";

export function Layout({ children }: { children: React.ReactNode }) {
  return (
    <div className="relative isolate min-h-dvh bg-bg-base text-slate-200">
      <TriangleGrid />
      <div className="triangle-grid-frost pointer-events-none fixed inset-0" aria-hidden="true" />
      <Nav />
      <main className="relative z-10 pt-[var(--stage-banner-h)]">{children}</main>
      <StageBanner />
    </div>
  );
}
